import React from "react"
import { accessFromProps } from "../lib/book-access"
import { BookShell } from "../components/book-shell"
import { PageHeader } from "../components/page-header"
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card"
import { SalesResourceCrud } from "./sales-page"

export function CreditNotesPage(props) {
  const {
    active_slug,
    section,
    section_title,
    user_name,
    access_role,
    can_create_company,
    can_enter_transactions,
    can_approve_documents,
    can_manage_company_settings,
    is_viewer,
  } = props

  const access = accessFromProps(props)

  const key = section || "all"

  return (
    <BookShell activeSlug={active_slug || "credit-notes"} userName={user_name} access={access}>
      <div className="flex flex-col gap-6">
        <PageHeader
          context="Sales · Adjustments"
          title={section_title}
          description="Phase 1 mirrors Zoho Books: issue credit notes against customers, track open vs applied amounts. Later phases add PDF, email, and apply-to-invoice flows."
        />

        {key === "all" ? (
          <SalesResourceCrud sectionKey="credit-notes" sectionTitle={section_title} access={access} />
        ) : null}

        {key === "applied" ? (
          <SalesResourceCrud
            sectionKey="credit-notes"
            sectionTitle={section_title}
            access={access}
            listParams={{ status: "applied" }}
            hideForm
          />
        ) : null}

        {key === "preferences" ? (
          <Card>
            <CardHeader>
              <CardTitle>Preferences</CardTitle>
            </CardHeader>
            <CardContent className="space-y-3 text-sm leading-relaxed text-muted-foreground">
              <p>Phase 2: numbering series, default tax treatment, and credit note templates (aligned with Zoho&apos;s settings).</p>
            </CardContent>
          </Card>
        ) : null}
      </div>
    </BookShell>
  )
}
